export default {
  info1: 'Nesta seção, você pode configurar como o acesso remoto e desatendido é realizado por meio de serviços web. Você deve indicar qual tipo de acesso é necessário e suas credenciais. Consulte com seu integrador para saber qual tipo de acesso deve ser configurado.',
  info2: 'Se você usa o Conector Sistema eFactura, precisará configurar o acesso por chave.',
  title: 'Configuração de acesso por ERP',
  radioButtons: {
    unauthorized: 'Não autorizado',
    byPassword: 'Por senha',
    byKey: 'Por chave'
  },
  help: 'Chave eletrônica (arquivo) que permitirá o acesso ao serviço de forma remota. Esta chave estará criptografada com a senha e deve ser usada juntamente com o arquivo na chamada para acesso remoto.',
  accessType: 'Tipo de acesso',
  id: '51234567A',
  downloadKey: 'Baixar Chave',
  identifier: 'Identificador',
  password: 'Senha',
  confirmPassword: 'Confirmar senha'
}